/**
 * Classify React Query / Supabase errors for retry and Rollbar reporting.
 * Extracted for unit testing.
 */

export function extractHttpStatus(error: unknown): number | null {
  if (!error || typeof error !== "object") return null;
  const e = error as Record<string, unknown>;

  if (typeof e.status === "number") return e.status;
  if (typeof e.statusCode === "number") return e.statusCode;

  if (typeof e.code === "string") {
    if (e.code === "PGRST301" || e.code === "PGRST302") return 401;
  }

  return null;
}

export function isClientError(error: unknown): boolean {
  const status = extractHttpStatus(error);
  return status !== null && status >= 400 && status < 500;
}

/** Exponential backoff for transient query retries (cap 8s). */
export function queryRetryDelay(attemptIndex: number): number {
  return Math.min(1_000 * 2 ** attemptIndex, 8_000);
}

/** Whether a failed query should be retried (max 3 attempts). */
export function shouldRetryQuery(failureCount: number, error: unknown): boolean {
  if (isClientError(error)) return false;
  return failureCount < 3;
}
